<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'ContactModuleRulesEnabled',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      
      return this.$t('notification.contactModuleRulesEnabled', {
        actor: `<strong>${actor}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

